import $ from 'jquery'

let $panel,
    $loading

export const showLoading = () => $loading.addClass( 'shown' )

export const hideLoading = () => $loading.removeClass( 'shown' )

const init = () => {
  $panel   = $( '.your-chat__panel' )  .first(),
  $loading = $panel                    .find( '.loading' )
}

export default () => init()
